
import { useState } from 'react';
import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from "@tanstack/react-query";
import { captureException } from "@/services/sentryService";

interface QueryClientProviderProps {
  children: React.ReactNode;
}

const QueryClientProvider = ({ children }: QueryClientProviderProps) => {
  // Create a client instance inside the component to avoid invalid hook calls
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        // Fixed: Use meta property for custom error handling in QueryClient
        meta: {
          errorHandler: (error: unknown) => {
            console.error('Query error:', error);
            // Safely capture the error in Sentry
            if (error instanceof Error) {
              captureException(error);
            }
          }
        }
      }
    }
  }));

  return (
    <ReactQueryClientProvider client={queryClient}>
      {children}
    </ReactQueryClientProvider>
  );
};

export default QueryClientProvider;
